<template>
    <div class="cinco-section">
        <div class="cinco-content">
            <h2 class="cinco-title fuente-posm">
                Tus clientes esperan 5 estrellas
            </h2>
            <p class="cinco-text fuente-nova">
                Hazlos sentir atendidos, no interrogados. Con Efisense Feedback, contestan por WhatsApp o QR en segundos.
            </p>
        </div>
        <div class="cinco-image">
            <img :src="a58" alt="5 Estrellas">
        </div>
    </div>
</template>

<script>
export default {
    name: 'CincoEstrellasFeedbackNew',
    data() {
        return {
            a58: require('@/assets/images/a58.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.cinco-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.cinco-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.cinco-image img {
    width: 300px;
    height: auto;
}

.cinco-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.cinco-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.cinco-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .cinco-title {
        font-size: 60px;
    }

    .cinco-text {
        font-size: 27px;
    }

    .cinco-image img {
        width: 250px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .cinco-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .cinco-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .cinco-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .cinco-image img {
        width: 50%;
        max-width: 200px;
    }

    .cinco-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .cinco-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
